// components/Header.js
import React from 'react';
import './Header.css';
import Hamburger from './hamburger';

function Header() {
  return (
    <header className="header">
      <nav className="navigation">
        <ul>
          <li>NFTs</li>
        </ul>
      </nav>
      <div className="menu-toggle">
        <Hamburger/>
      </div>
    </header>
  );
}

export default Header;
